import src from "IMAGE";
export default { src, width: 1920, height: 384, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAPklEQVR42hXJSwoAIAgE0JIgFPGDEN2g9t3/bulsZobXRsbdt6re7BcRz8xO/l3WAKAT0WRmE5GVuGoj4iz7gFUDcvoCdTsAAAAASUVORK5CYII="};
